import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Grid,
    Typography
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
    render() {
        const SlabReportSearchData = this.props.SlabReportSearchData;
        const CropSlabData = this.props.CropSlabData;
        const TotalAmount = this.props.TotalAmount;

        return (
            <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                <br />
                <h2><center><u>Customer Crop Slab Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>{SlabReportSearchData.groupName} - {SlabReportSearchData.factoryName}</center></h3>
                <h3><center>{SlabReportSearchData.routeName == undefined ? 'All Route' : SlabReportSearchData.routeName}</center></h3>
                <h3><center> ( {SlabReportSearchData.startDate} - {SlabReportSearchData.endDate} )</center></h3>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table" size='small'>
                                <TableHead style={{ border: "1px solid #ccc" }}>
                                    <TableRow>
                                        <TableCell align={'left'} style={{ borderRight: "1px solid #ccc" }}>Route</TableCell>
                                        <TableCell align={'left'} style={{ borderRight: "1px solid #ccc" }}>Registration Number</TableCell>
                                        <TableCell align={'left'} style={{ borderRight: "1px solid #ccc" }}>Supplier Name</TableCell>
                                        <TableCell align={'right'} style={{ borderRight: "1px solid #ccc" }}>Crop (KG)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ border: "1px solid #ccc" }}>
                                    {CropSlabData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                                {data.cropNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow style={{ border: "1px solid #ccc" }}>
                                    <TableCell align={'left'} ><b>Total</b></TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderRight: "1px solid #ccc" }}>
                                        <b> {TotalAmount.cropNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}